import { PMCommissionCoefficient } from "./constants/comissions";

export function formatMoney(amount: number): string {
  return !amount
    ? "0.00"
    : amount.toLocaleString("en", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
}

export function calculateFee(amount) {
  const fee = amount * (PMCommissionCoefficient - 1);
  return Number(Math.round((fee + Number.EPSILON) * 100) / 100).toFixed(2);
}

export function formatAmount(amount: number): string {
  return !Math.ceil(amount)
    ? "0"
    : (amount >= 0 ? Math.floor(amount) : Math.ceil(amount)).toLocaleString(
        "en",
        {
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        },
      );
}

/**
 * A rate as a percentage, or an em dash when there is not one yet.
 *
 * `${(fee * 100).toFixed(2)}%` was written out at each call site, and an
 * undefined rate makes `NaN` — which `toFixed` turns into the STRING "NaN",
 * so the invest dialog advertised its management fee as "NaN%" for as long as
 * the smartfolio took to load. Optional chaining does not help: the value is
 * a number, it is just not a real one.
 */
export function formatPercent(rate?: number, precision = 2): string {
  return Number.isFinite(rate) ? `${(rate * 100).toFixed(precision)}%` : "—";
}

export function fixNumber(number: number, precision = 2) {
  return number ? Number(Number(number).toFixed(precision)) : 0;
}

export function formatPrecisionNumber(number: number, precision: number) {
  return fixNumber(number / 10 ** precision);
}

// calculate the total amount + % of TP or SL
export function calculeTPSL(amount: any, TP_SL: any) {
  return fixNumber(amount * (1 + TP_SL / 100));
}

export function calcRendement(nav: any, initialNav: any) {
  const ratio = nav / initialNav;
  const rendement = ratio - 1;
  return fixNumber(rendement * 100);
}

export const calcCurrentNav = (investment: any) =>
  investment.nav ? Number(investment.nav).toFixed(2) : "-";

export const calcPercentage = (percent: number, total: number): number => {
  return (percent / 100) * total;
};

/**
 * A percentage with its sign: "-0.02%" for a loss, "1.25%" for a gain.
 *
 * Returns were printed as a magnitude beside an arrow, so a loss read
 * "↘ 0.02%" — the direction only in the arrow and the colour, and gone
 * the moment the figure is read aloud, copied, or seen without colour. A
 * loss now carries its minus too; a figure that rounds to zero carries none
 * ("-0.00%" says nothing). `value` is already in per cent.
 */
export const signedPercent = (value: number, digits = 2) => {
  const n = Number(value);
  if (!Number.isFinite(n)) return "—";
  const magnitude = Math.abs(n).toLocaleString("en", {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  });
  const rounded = Number(Math.abs(n).toFixed(digits));
  return `${n < 0 && rounded !== 0 ? "-" : ""}${magnitude}%`;
};
